<template>
  <div class="idea-al">
    <div class="idea">
      <h3><span>美菜理念</span>／Meicai Idea</h3>
      <div class="info">
        <p class="name">为了一个不变的承诺——让老百姓生活更简单</p>
        <p class="text">
          美菜网前期以中小型餐饮商户为切入点，专注为全国近百万家餐厅提供一站式、全品类且更低价、更新鲜的餐饮原材料采购服务。为客户提供省时省力、省钱省心的原材料，实现全程无忧的采购。通过对采购、质检、仓储、物流等流程科学精细化的管理，解决农民农产品滞销问题。
        </p>
      </div>
      <div class="meicai-three">
        <div class="block sm">
          <div class="title">美菜使命</div>
          <div class="present">
            <ul class="p-in-a">
              <li>改变国内农业</li>
              <li>为8亿农民谋幸福</li>
            </ul>
            <!-- <p class="p-in-a"></p> -->
          </div>
        </div>
        <div class="block yj">
          <div class="title">美菜愿景</div>
          <div class="present">
            <ul class="p-in-b">
              <li>
                成为全球最具竞争力的食品生鲜供应链服务平台，服务1000万家门店和1亿消费者
              </li>
              <li>成就3000家年销售额1亿元以上的合作伙伴，为国内2亿农民增收</li>
              <li>成为人人引以为傲的百年企业</li>
            </ul>
          </div>
        </div>
        <!-- <div class="block jzg">
          <div class="title">美菜价值观</div>
          <div class="present">
            <p class="p-in-c" style="padding-top:20px; line-height:1.5">
              <b>客户第一：</b>
              <br />使命要求，明确方向，以客户为导向
              <br />
              <b>担当、拥抱变化：</b>
              <br />展开双臂，肩担责任，同时拥抱变化
              <br />
              <b>勤俭、诚信：</b>
              <br />根基，双脚扎在泥土里，才能顶天立地
              <br />
              <b>热爱：</b>
              <br />核心，一颗赤子心，由内而外激发的6个价值观
              <br />
              <b>持续成长：</b>
              <br />外环不断循环，自我完善；成为生态
               客户第一：站在客户立场思考问题<br/>团结合作：责任担当，开放分享<br/>拥抱变化：心态皮实，挑战现状<br/>诚信：言行坦荡，实事求是<br/>热爱：永远不要低估一颗总冠军的心<br/>持续成长：每天进步一点点 
            </p>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "idea",
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.idea-al {
  width: 100%;
  padding: 50px 0;
  display: inline-block;
  b {
    font-weight: 550;
  }
}
.idea {
  width: 1000px;
  margin: 0 auto;
  h3 {
    margin: 0;
    padding: 0;
    font-size: 18px;
    text-align: center;
    color: #262626;
    span {
      font-size: 30px;
    }
  }
  .info {
    padding: 32px 5% 72px;
    .name {
      text-align: center;
      color: rgba(38, 38, 38, 1);
      font-size: 18px;
      line-height: 25px;
    }
    .text {
      padding-top: 8px;
      line-height: 26px;
      color: rgba(117, 117, 117, 1);
    }
  }
  .meicai-three {
    width: 100%;
    display: flex;
  }
  .block {
    height: 198px;

    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .title {
      border-radius: 58px;
      width: 148px;
      height: 44px;
      text-align: center;
      line-height: 44px;
      color: #fff;
      font-size: 20px;
      position: absolute;
      top: 0;
      margin-top: -22px;
    }
    .present {
      display: table;
      ul {
        line-height: 35px;
        color: rgba(59, 59, 59, 1);
        font-size: 15px;
      }
      .p-in-a {
        li::before {
          content: "• ";
          color: #609fe9; /* or whatever color you prefer */
        }
      }
      .p-in-b {
        li::before {
          content: "• ";
          color: #4acb81; /* or whatever color you prefer */
        }
      }
      .p-in-c {
        padding-top: 60px;
      }
    }
  }
  .sm {
    background: #f7faff;
    border-radius: 40px;
    width: 305px;
    margin-right: 50px;
    .title {
      /*background-image:linear-gradient(90deg, rgba(131,182,241,0.75) 3%, #458de5 100%);*/
      background: url(https://img-oss.yunshanmeicai.com/cfile/6616b0e31c71625bff1461c339f275f6.png)
        no-repeat;
      width: 148px;
      height: 44px;
    }
  }
  .yj {
    background: #f4fcf8;
    border-radius: 40px;
    flex: 1;
    .present {
      font-size: 15px;
    }
    .title {
      /*background-image:linear-gradient(90deg, rgba(118,215,159,0.72) 3%, #4ac984 100%);*/
      background: url(https://img-oss.yunshanmeicai.com/cfile/7ca79c6d1f178a323606858cfe8e2c16.png)
        no-repeat;
      width: 148px;
      height: 44px;
    }
  }
  .jzg {
    margin-right: 0;
    background: #fff8f8;
    .title {
      /*background-image:linear-gradient(90deg, rgba(255,127,127,0.63) 3%, #ff7f7f 100%);*/
      background: url(https://img-oss.yunshanmeicai.com/cfile/b64e3342cb389b047d65019047773032.png)
        no-repeat;
      width: 148px;
      height: 44px;
    }
  }
  .character {
    padding-top: 55px;
    text-align: center;
    .alt-name {
      font-size: 20px;
    }
    .alt-text {
      padding-top: 25px;
      line-height: 2;
      color: #757575;
    }
  }
}
</style>
